import { APIData, appFetch } from ".";

export const partnersAPI = {
  fetchPage(page: number) {
    return appFetch<APIData<Partner[]>>("/partners?page=" + page);
  },
};
